import { fromZonedTime } from 'date-fns-tz';
import { useCallback } from 'react';

export const useGetZonedSlotStart = () =>
  useCallback(
    (day: Date, timezone: string, hour = 0, minute = 0): Date =>
      fromZonedTime(new Date(day.getFullYear(), day.getMonth(), day.getDate(), hour, minute, 0), timezone),
    [],
  );
